<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div
        class="page-actions"
        style="display: flex; justify-content: space-between"
      >
        <div class="select">
          <!-- <div class="item">
            <el-button
              size="mini"
              type="primary"
              @click="handleSearch({ page: 1 })"
              >查询</el-button
            >
          </div> -->

          <div class="item">
            <el-button
              v-if="$hasPerm('tenant:copy_trader_level:add')"
              size="mini"
              type="primary"
              @click="show('新增')"
              >新增</el-button
            >
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="500">
        <el-table-column label="交易员等级级别" prop="level" />
        <el-table-column label="交易员等级名称" prop="levelName" />
        <el-table-column prop="" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">正常</span>
            <span v-if="scope.row.status == 0">删除</span>
          </template>
        </el-table-column>

        <el-table-column label="最大跟单人数" prop="maxFollowerSize" />
        <el-table-column label="分润比例" prop="profitRate" />
        <el-table-column label="合约总权益" prop="totalEquity" />
        <el-table-column label="合约收益率" prop="yield" />
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="$hasPerm('tenant:copy_trader_level:edit')"
              type="text"
              size="mini"
              @click="show('编辑', scope.row)"
              >编辑</el-button
            >
            <el-button
              v-if="$hasPerm('tenant:copy_trader_level:delete')"
              type="text"
              size="mini"
              @click="del(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="paginationHandle"
      >
      </pagination> -->

      <el-dialog
        :title="title"
        :visible="dialogVisible"
        width="600px"
        @close="close"
        :destroy-on-close="true"
      >
        <el-form
          ref="formData"
          :model="formData"
          size="medium"
          label-width="200px"
        >
          <el-form-item label="交易员等级级别" prop="">
            <el-input-number v-model="formData.level" :precision="0">
            </el-input-number>
          </el-form-item>
          <el-form-item label="交易员等级名称" prop="">
            <el-input v-model="formData.levelName"> </el-input>
          </el-form-item>
          <el-form-item label="最大跟单人数" prop="" :precision="0">
            <el-input-number v-model="formData.maxFollowerSize">
            </el-input-number>
          </el-form-item>
          <el-form-item label="分润比例" prop="" :precision="4">
            <el-input-number v-model="formData.profitRate"> </el-input-number>
          </el-form-item>
          <el-form-item label="合约总权益" prop="">
            <el-input-number v-model="formData.totalEquity"> </el-input-number>
          </el-form-item>
          <el-form-item label="合约收益率" prop="" :precision="4">
            <el-input-number v-model="formData.yield"> </el-input-number>
          </el-form-item>

          <el-form-item label="状态" prop="">
            <el-select v-model="formData.status" clearable>
              <el-option
                v-for="item in statusArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="close">取消</el-button>
          <el-button
            v-if="canSaveCurrentDialog"
            type="primary"
            @click="handleSave"
            >确定</el-button
          >
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "./api";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      tabList: [],
      totalCount: 0,
      pagination: {
        page: 1,
        size: 25,
      },
      dialogVisible: false,
      title: "新增",
      statusArr: [
        { label: "正常", value: 1 },
        { label: "删除", value: 0 },
      ],
      formData: {
        level: "",
        levelName: "",
        maxFollowerSize: "",
        profitRate: "",
        totalEquity: "",
        yield: "",
        status: 0,
      },
    };
  },
  computed: {
    canSaveCurrentDialog() {
      if (this.title === "编辑") {
        return this.$hasPerm("tenant:copy_trader_level:edit");
      }
      return this.$hasPerm("tenant:copy_trader_level:add");
    },
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    handleSearch(data = {}) {
      api
        .copytradeLevelList({
          // ...this.pagination,
          // ...data,
        })
        .then((res) => {
          if (res.code == 0) {
            this.tabList = res.data;
            // this.totalCount = totalCount;
          }
        });
    },
    paginationHandle(pagination) {
      this.pagination = pagination;
      this.handleSearch();
    },
    show(str, row) {
      if (row) {
        this.formData = JSON.parse(JSON.stringify(row));
      }
      this.title = str;
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
      this.formData = {
        level: "",
        levelName: "",
        maxFollowerSize: "",
        profitRate: "",
        totalEquity: "",
        yield: "",
        status: 0,
      };
    },
    handleSave() {
      // if (this.formData.id == "") {
      //   return this.$message.error("请选择交易对ID");
      // }
      let url = "";
      this.title == "编辑"
        ? (url = "copytradeLeaderLevelEdit")
        : (url = "copytradeLeaderLevelAdd");
      api[url](this.formData).then((res) => {
        if (res.code == 0) {
          this.$message.success(this.title + "成功");
          this.close();
          this.handleSearch();
        }
      });
    },
    del(row) {
      this.$confirm("确认进行该操作吗？", "提示", {
        type: "warning",
      }).then(() => {
        api.copytradeLeaderLevelDel({ id: row.id }).then((res) => {
          if (res.code == 0) {
            this.$message.success("操作成功！");
            this.handleSearch();
          }
        });
      });
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
<style scoped lang="less">
/deep/ .el-form-item {
  margin-bottom: 10px;
}
/deep/ .el-radio-group {
  margin-bottom: 10px;
  margin-top: -6px;
  margin-left: 45px;
}
/deep/ .el-input,
.el-input-number {
  width: 220px;
}
.flex {
  display: flex;
  gap: 40px;
  justify-content: center;
  align-items: center;
  &:not(:first-child) {
    margin-top: 8px;
  }
}
</style>
